import React from "react";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import Navbar from "./components/Navbar";
import Footer from "./components/Footer";
import ScrollToHash from "./components/ScrollToHash";
import HomePage from "./pages/HomePage";
import ToolsHub from "./pages/tools/ToolsHub";
import ToolPage from "./pages/tools/ToolPage";
import { ScheduleCallProvider } from "./context/ScheduleCallContext";

function App() {
  return (
    <BrowserRouter>
      <ScheduleCallProvider>
      <ScrollToHash />
      <div className="bg-dark-400 text-white min-h-screen">
        <Navbar />
        <main id="main-content" aria-label="Main content">
          <Routes>
            <Route path="/" element={<HomePage />} />
            <Route path="/tools" element={<ToolsHub />} />
            <Route path="/tools/:slug" element={<ToolPage />} />
          </Routes>
        </main>
        <Footer />
      </div>
      </ScheduleCallProvider>
    </BrowserRouter>
  );
}

export default App;
